import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../redux';
import { useLazyQuery } from '@apollo/client';
import { FIND_DISCOUNT_BY_CODE } from '../../../apollo';
import { discountSlice } from '../../../redux';

export const useFindDiscountByCodeEffect = (callback?: () => void) => {
  const dispatch = useDispatch();
  const discount = useSelector((state: StoreState) => state.catalog.discount);

  const [doFindDiscountByCode, { loading }] = useLazyQuery(
    FIND_DISCOUNT_BY_CODE,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        if (data.findDiscountByCode === null) {
          dispatch(discountSlice.actions.error('Discount Code doesnt Exist'));
        } else {
          if (data.errors) {
            dispatch(
              discountSlice.actions.error(
                data.findDiscountByCode.errors[0].message
              )
            );
          } else {
            dispatch(discountSlice.actions.update(data.findDiscountByCode));
          }
        }
        if (callback) {
          callback();
        }
      },
      onError: () => {
        dispatch(
          discountSlice.actions.error('Retrieving discount details failed!')
        );
      },
    }
  );

  const findDiscountByCode = (code: string) => {
    const variables = { code };
    doFindDiscountByCode({ variables });
    dispatch(discountSlice.actions.loading());
  };

  return { discount, findDiscountByCode, loading };
};
